module.exports = __webpack_public_path__ + "static/img/Teig-Wilton.c7d311f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Teig-Wilton.jpg
// module id = eIMw
// module chunks = 0